<app-progress-bar [isLoading]="isLoadingFilters"></app-progress-bar>
<div class="row mt-3">
  <div class="col-lg-3 col-md-3">
    <div class="form-group">
      <div class="left inline control-label mb-1">Published From</div>
      <div class="input-group input-group-sm" *ngIf="rulebookFiltersData && rulebookFiltersData.fromDate">
        <input matInput [matDatepicker]="picker" (click)="picker.open()" placeholder="Choose a date"
          class="form-control form-control-sm border-bottom" id="fromDate" placeholder="From"
          [(ngModel)]="rulebookFiltersData.fromDate" readonly>
        <div class="input-group-append">
          <span class="input-group-text fa fa-calendar" (click)="picker.open()"></span>
        </div>
      </div>
      <mat-datepicker #picker></mat-datepicker>
    </div>
  </div>
  <div class="col-lg-3 col-md-3">
    <div class="form-group">
      <div class="left inline control-label d-none d-sm-block mb-1">Published Until</div>
      <div class="input-group input-group-sm" *ngIf="rulebookFiltersData && rulebookFiltersData.toDate">
        <input matInput [matDatepicker]="toPicker" (click)="toPicker.open()" placeholder="Choose a date"
          class="form-control form-control-sm border-bottom" id="toDate" placeholder="To"
          [(ngModel)]="rulebookFiltersData.toDate" readonly>
        <div class="input-group-append">
          <span class="input-group-text fa fa-calendar" (click)="toPicker.open()"></span>
        </div>
      </div>
      <mat-datepicker #toPicker></mat-datepicker>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group">
      <div class="left inline control-label mb-1">Id </div>
      <mat-chip-grid #idList>
        <mat-chip-row *ngFor="let type of rulebookFiltersData.rulebookId" [selectable]="selectable" [removable]="removable"
          (removed)="removeRegulationId(type)">
          {{type}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip-row>
        <input class="form-control form-control-sm border-bottom" type="number" id="type" autocomplete="off"
          [matChipInputFor]="idList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addRegulationId($event)">
      </mat-chip-grid>
    </div>
  </div>
  <div class="col-lg-3 col-md-3">
    <div class="form-group">
      <div class="left inline control-label mb-1">Geography</div>
      <mat-chip-grid #geographyList>
        <mat-chip-row *ngFor="let geography of rulebookFiltersData.geography" [selectable]="selectable"
          [removable]="removable" (removed)="removeGeography(geography)">
          {{geography}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip-row>
        <input class="form-control form-control-sm mat-autodd-input" #geographyInput
          [formControl]="searchGeographyCntrl" [matAutocomplete]="geographyAutocomplete"
          [matChipInputFor]="geographyList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur" autocomplete="off" (matChipInputTokenEnd)="addGeography($event)">
      </mat-chip-grid>
      <mat-autocomplete #geographyAutocomplete="matAutocomplete" (optionSelected)="selectedGeographyEvent($event)">
        <mat-option *ngFor="let geography of searchedGeography" [value]="geography.value">
          {{geography.name}}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div class="col-lg-3 col-md-3">
    <div class="form-group">
      <div class="left inline control-label mb-1">Country</div>
      <mat-chip-grid #countryList>
        <mat-chip-row *ngFor="let country of rulebookFiltersData.country" [selectable]="selectable"
          [removable]="removable" (removed)="removeCountry(country)">
          {{country}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip-row>
        <input class="form-control form-control-sm mat-autodd-input" #countryInput [formControl]="searchCountryCntrl"
          [matAutocomplete]="countryAutocomplete" [matChipInputFor]="countryList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
          (matChipInputTokenEnd)="addCountry($event)">
      </mat-chip-grid>
      <mat-autocomplete #countryAutocomplete="matAutocomplete" (optionSelected)="selectedCountryEvent($event)">
        <mat-option *ngFor="let country of searchedCountry" [value]="country.value">
          {{country.name}}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div class="col-lg-3 col-md-3">
    <div class="form-group">
      <div class="left inline control-label mb-1">Rulebook Name</div>
      <mat-chip-grid #rulebookList>
        <mat-chip-row *ngFor="let rulebook of rulebookFiltersData.rulebook" [selectable]="selectable"
          [removable]="removable" (removed)="removeRulebook(rulebook)">
          {{rulebook}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip-row>
        <input class="form-control form-control-sm mat-autodd-input" #rulebookInput [formControl]="searchRulebookCntrl"
          [matAutocomplete]="rulebookAutocomplete" [matChipInputFor]="rulebookList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
          (matChipInputTokenEnd)="addRulebook($event)">
      </mat-chip-grid>
      <mat-autocomplete #rulebookAutocomplete="matAutocomplete" (optionSelected)="selectedRulebook($event)">
        <mat-option *ngFor="let rulebook of searchedRulebook" [value]="rulebook.value">
          {{rulebook.name}}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div class="col-lg-3 col-md-3">
    <div class="form-group">
      <div class="left inline control-label mb-1">Key Words</div>
      <mat-chip-grid #keywordsList>
        <mat-chip-row *ngFor="let sQuery of rulebookFiltersData.searchQuery" [selectable]="selectable"
          [removable]="removable" (removed)="remove(sQuery)">
          {{sQuery}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip-row>
        <input class="form-control form-control-sm mat-autodd-input" #keywordInput [formControl]="keyCtrl"
          [matAutocomplete]="autoKeyword" [matChipInputFor]="keywordsList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
          (matChipInputTokenEnd)="add($event)">
      </mat-chip-grid>
      <mat-autocomplete #autoKeyword="matAutocomplete" (optionSelected)="selected($event)">
        <mat-option *ngFor="let fK of filteredKeywords " [value]="fK">
          {{fK}}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div class="col-lg-3 col-md-3">
    <div class="form-group">
      <div class="left inline control-label mb-1">Part</div>
      <mat-chip-grid #chipGridHeader>
        <mat-chip-row *ngFor="let header of rulebookFiltersData.headers" (removed)="removeHeader(header)"
          [editable]="true" (edited)="editHeader(header, $event)">
          {{header}}
          <button matChipRemove >
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
        <input class="form-control" [matChipInputFor]="chipGridHeader" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addHeader($event)" />
      </mat-chip-grid>
    </div>
  </div>
  <div class="col-lg-3 col-md-3">
    <div class="form-group">
      <div class="left inline control-label mb-1">Rule Text</div>
      <mat-chip-grid #chipGridRuleText>
        <mat-chip-row *ngFor="let ruleText of rulebookFiltersData.ruleText" (removed)="removeRuleText(ruleText)"
          [editable]="true" (edited)="editRuleText(ruleText, $event)">
          {{ruleText}}
          <button matChipRemove >
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
        <input class="form-control" [matChipInputFor]="chipGridRuleText" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addRuleText($event)" />
      </mat-chip-grid>
    </div>
  </div>
  <div class="col-lg-3 col-md-3">
    <div class="form-group">
      <div class="left inline control-label mb-1">Related Provisions</div>
      <mat-chip-grid #chipGridRelatedProvision>
        <mat-chip-row *ngFor="let relatedProvision of rulebookFiltersData.relatedProvisions" (removed)="removeRelatedProvisions(relatedProvision)"
          [editable]="true" (edited)="editRelatedProvisions(relatedProvision, $event)">
          {{relatedProvision}}
          <button matChipRemove >
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
        <input class="form-control" [matChipInputFor]="chipGridRelatedProvision" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addRelatedProvisions($event)" />
      </mat-chip-grid>
    </div>
  </div>
  <div class="col-lg-3 col-md-3">
    <div class="form-group">
      <div class="left inline control-label mb-1">Spiderlinks</div>
      <mat-chip-grid #chipGridSpiderLink>
        <mat-chip-row *ngFor="let spiderLink of rulebookFiltersData.spiderLinks" (removed)="removeSpiderLinks(spiderLink)"
          [editable]="true" (edited)="editSpiderLinks(spiderLink, $event)">
          {{spiderLink}}
          <button matChipRemove >
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
        <input class="form-control" [matChipInputFor]="chipGridSpiderLink" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addSpiderLinks($event)" />
      </mat-chip-grid>
    </div>
  </div>
  <div class="col-lg-3 col-md-3">
    <div class="form-group">
      <div class="left inline control-label mb-1">Owner</div>
      <mat-chip-grid #ownerList>
        <mat-chip-row *ngFor="let owner of rulebookFiltersData.owner" [selectable]="selectable"
          [removable]="removable" (removed)="removeOwner(owner)">
          {{owner}}
          <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
        </mat-chip-row>
        <input class="form-control form-control-sm mat-autodd-input" #ownerInput
          [formControl]="searchOwnerCntrl" [matAutocomplete]="ownerAutocomplete"
          [matChipInputFor]="ownerList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur" autocomplete="off" (matChipInputTokenEnd)="addOwner($event)">
      </mat-chip-grid>
      <mat-autocomplete #ownerAutocomplete="matAutocomplete" (optionSelected)="selectedOwnerEvent($event)">
        <mat-option *ngFor="let owner of searchedOwner" [value]="owner">
          {{owner}}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div class="col-lg-3 col-md-3">
    <div class="form-group">
      <div class="left inline control-label mb-1">Obligation</div>
        <mat-chip-grid #chipGridObligation>
          <mat-chip-row *ngFor="let obligation of rulebookFiltersData.obligation" (removed)="removeObligation(obligation)"
            [editable]="true" (edited)="editObligation(obligation, $event)">
            {{obligation}}
            <button matChipRemove >
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
          <input class="form-control" [matChipInputFor]="chipGridObligation" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addObligation($event)" />
        </mat-chip-grid>
    </div>
  </div>
  <div class="col-lg-3 col-md-3">
    <div class="form-group">
      <div class="left inline control-label mb-1">Risk</div>
      <mat-chip-grid #chipGridRisk>
        <mat-chip-row *ngFor="let risk of rulebookFiltersData.risk" (removed)="removeRisk(risk)"
          [editable]="true" (edited)="editRisk(risk, $event)">
          {{risk}}
          <button matChipRemove >
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
        <input class="form-control" [matChipInputFor]="chipGridRisk" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addRisk($event)" />
      </mat-chip-grid>
    </div>
  </div>
  <div class="col-lg-3 col-md-3">
    <div class="form-group">
      <div class="left inline control-label mb-1">Controls</div>
      <mat-chip-grid #chipGridControls>
        <mat-chip-row *ngFor="let controls of rulebookFiltersData.controls" (removed)="removeControls(controls)"
          [editable]="true" (edited)="editControls(controls, $event)">
          {{controls}}
          <button matChipRemove >
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
        <input class="form-control" [matChipInputFor]="chipGridControls" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addControls($event)" />
      </mat-chip-grid>
      <!-- <input class="form-control form-control-sm mat-autodd-input" [(ngModel)]="rulebookFiltersData.controls"> -->
    </div>
  </div>
  <div class="col-lg-3 col-md-3">
    <div class="form-group">
      <div class="left inline control-label mb-1">Summary</div>
      <mat-chip-grid #chipGridSummary>
        <mat-chip-row *ngFor="let summary of rulebookFiltersData.summary" (removed)="removeSummary(summary)"
          [editable]="true" (edited)="editSummary(summary, $event)">
          {{summary}}
          <button matChipRemove >
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
        <input class="form-control" [matChipInputFor]="chipGridSummary" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addSummary($event)" />
      </mat-chip-grid>
      <!-- <input class="form-control form-control-sm mat-autodd-input" [(ngModel)]="rulebookFiltersData.summary"> -->
    </div>
  </div>
  <div class="col-lg-3 col-md-3">
    <div class="form-group">
      <div class="left inline control-label mb-1">Interpretation</div>
      <mat-chip-grid #chipGridInterpretation>
        <mat-chip-row *ngFor="let interpretation of rulebookFiltersData.interpretation" (removed)="removeInterpretation(interpretation)"
          [editable]="true" (edited)="editInterpretation(interpretation, $event)">
          {{interpretation}}
          <button matChipRemove >
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
        <input class="form-control" [matChipInputFor]="chipGridInterpretation" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addInterpretation($event)" />
      </mat-chip-grid>
      <!-- <input class="form-control form-control-sm mat-autodd-input" [(ngModel)]="rulebookFiltersData.interpretation"> -->
    </div>
  </div>
  <div class="col-lg-3 col-md-3">
    <div class="form-group">
      <div class="left inline control-label mb-1">Related Documentation</div>
      <mat-chip-grid #chipGridLinkedControls>
        <mat-chip-row *ngFor="let linkedControls of rulebookFiltersData.linkedControls" (removed)="removeLinkedControls(linkedControls)"
          [editable]="true" (edited)="editLinkedControls(linkedControls, $event)">
          {{linkedControls}}
          <button matChipRemove >
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
        <input class="form-control" [matChipInputFor]="chipGridLinkedControls" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addLinkedControls($event)" />
      </mat-chip-grid>
      <!-- <input class="form-control form-control-sm mat-autodd-input" [(ngModel)]="rulebookFiltersData.linkedControls"> -->
    </div>
  </div>
  <div class="col-lg-2 col-md-2">
    <div class="form-group">
      <div class="left inline control-label mb-1">
        <i class="fa fa-square-o icon-font" (click)="rulebookFiltersData.isShowAllRule = true"
          *ngIf="!rulebookFiltersData.isShowAllRule" aria-hidden="true"></i>
        <i class="fa fa-check-square icon-font" (click)="rulebookFiltersData.isShowAllRule = false"
          *ngIf="rulebookFiltersData.isShowAllRule" aria-hidden="true"></i>
        Show Applicable
      </div>
      <div class="left inline control-label mt-3">
        <i class="fa fa-square-o icon-font" (click)="rulebookFiltersData.isLatestVersion = true"
          *ngIf="!rulebookFiltersData.isLatestVersion" aria-hidden="true"></i>
        <i class="fa fa-check-square icon-font" (click)="rulebookFiltersData.isLatestVersion = false"
          *ngIf="rulebookFiltersData.isLatestVersion" aria-hidden="true"></i>
        Show Latest Rules
      </div>
    </div>
  </div>
  <div class="col-lg-4 col-md-4 pt-4">
    <div class="form-group">
      <button type="button" class="btn btn-sm ml-2" (click)="TriggerAction()">Submit</button>
      <button class="ml-2 btn btn-sm" (click)="initFilters()">Reset</button>
      <button class="ml-2 btn btn-sm" (click)="showRuleTree()">Show Rule Tree</button>
    </div>
  </div>
</div>